import React from 'react';
import { withStyles} from '@material-ui/core/styles';
import {Tooltip,Grid,Typography} from '@material-ui/core';
import WavesIcon from "./WavesIcon";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#00b8f5',
    color: 'white',
    maxWidth: 250,
    maxHeight:100,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip);

export default function LeftBanner() {

  return (
<Grid style={{position:"relative",top:"10%",textAlign:"center"}}>
    <HtmlTooltip
        title={
          <React.Fragment>
            <Typography color="inherit" style={{padding:"1vh"}}><b>PSSSTTTT.......</b></Typography>
            <Typography color="inherit" style={{padding:"1vh"}}>
            CLICK BELOW IF YOU LIKE THIS POST TO COPY THE LINK
            </Typography>
          </React.Fragment>
        }
      >
          <p>LIKE IT?   </p>
      </HtmlTooltip>
      <WavesIcon/>            
</Grid>
  );
}


// WEBPACK FOOTER //
// ./src/components/VIEW/LeftBanner.js